import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { shuffleSquaresAnim } from './animations'
// We use this transparency image as space inside squares
// this give us normal height in adaptive viewport
import dot from './assets/dot.gif'
import './ShuffleSquares.scss'

const PHOTO_COUNT = 47
const SQUARE_COUNT = 16
const PHOTOS = [...Array(PHOTO_COUNT).keys()].map(index =>
  require(`./assets/photo-${index}.jpg`),
)

/**
 * ShuffleSquares component — you can insert grid with smart-randomly show and hide squares.
 *
 * Squares might be purple, white or with showing one of a bunch of photos
 *
 * @return {Component} Component - ShuffleSquares
 */
class ShuffleSquares extends Component {
  constructor(props) {
    super(props)

    this.squaresAppeareTween = null
    this.squaresWrapper = React.createRef()
    this.innerSquares = [...Array(SQUARE_COUNT).keys()]
  }

  componentDidMount() {
    const { withPhoto } = this.props
    const params = {
      wrapper: this.squaresWrapper.current,
    }

    if (withPhoto) {
      this.loadAllImages()
      params.images = PHOTOS
    }
    this.squaresAppeareTween = shuffleSquaresAnim({ ...params })
  }

  componentWillUnmount() {
    if (this.squaresAppeareTween) {
      if (this.squaresAppeareTween.timeoutId) {
        clearTimeout(this.squaresAppeareTween.timeoutId)
      }

      this.squaresAppeareTween.kill()
    }
  }

  loadAllImages = () => {
    const allImages = []

    for (let i = 0; i < PHOTOS.length; i++) {
      allImages[i] = new Image()
      allImages[i].src = PHOTOS[i]
    }
  }

  renderInnerSquares = () => {
    return this.innerSquares.map(index => (
      <div className="square" key={index}>
        <img src={dot} alt="" />
      </div>
    ))
  }

  render() {
    const { theme } = this.props
    const className = `shuffle-squares shuffle-squares--${theme}`

    return (
      <div ref={this.squaresWrapper} className={className}>
        {this.renderInnerSquares()}
      </div>
    )
  }
}

ShuffleSquares.propTypes = {
  /** Theme of component */
  theme: PropTypes.oneOf(['purple', 'white', 'transparent']),

  /** With photo or not */
  withPhoto: PropTypes.bool,
}

ShuffleSquares.defaultProps = {
  withPhoto: false,
  theme: 'purple',
}

export default ShuffleSquares
